/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as o } from "../../core/maybe.js";
import r from "../Extent.js";
import e from "../Geometry.js";
import t from "../Multipoint.js";
import n from "../Point.js";
import i from "../Polygon.js";
import m from "../Polyline.js";

function u(o) {
  try {
    throw new Error("fromJson is deprecated, use fromJSON instead");
  } catch (r) {
    console.warn(r.stack);
  }

  return d(o);
}

function s(o) {
  return void 0 !== o.xmin && void 0 !== o.ymin && void 0 !== o.xmax && void 0 !== o.ymax;
}

function f(o) {
  return void 0 !== o.points;
}

function l(o) {
  return void 0 !== o.x && void 0 !== o.y;
}

function y(o) {
  return void 0 !== o.paths;
}

function c(o) {
  return void 0 !== o.rings;
}

function p(o) {
  return void 0 !== o.vertexAttributes;
}

function d(u) {
  return o(u) ? null : u instanceof e ? u : l(u) ? n.fromJSON(u) : y(u) ? m.fromJSON(u) : c(u) ? i.fromJSON(u) : f(u) ? t.fromJSON(u) : s(u) ? r.fromJSON(u) : null;
}

function v(o) {
  return o ? l(o) ? "esriGeometryPoint" : y(o) ? "esriGeometryPolyline" : c(o) ? "esriGeometryPolygon" : s(o) ? "esriGeometryEnvelope" : f(o) ? "esriGeometryMultipoint" : null : null;
}

var G = {
  esriGeometryPoint: n,
  esriGeometryPolyline: m,
  esriGeometryPolygon: i,
  esriGeometryEnvelope: r,
  esriGeometryMultipoint: t
};

function a(o) {
  return o && G[o] || null;
}

export { d as fromJSON, u as fromJson, a as getGeometryType, v as getJsonType, s as isExtent, p as isMesh, f as isMultipoint, l as isPoint, c as isPolygon, y as isPolyline };